// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"337":"11481fca9c89d00556b2","936":"d17c2cdbdad80aba98f1"}[chunkId] + ".js";
};